import { render, staticRenderFns } from "./DirectionSwitch.vue?vue&type=template&id=34c4f452&"
import script from "./DirectionSwitch.vue?vue&type=script&lang=ts&"
export * from "./DirectionSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./DirectionSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports